module.exports = __webpack_public_path__ + "img/20191228130056329.3d1d4492.jpg";